import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-local-ads',
  templateUrl: './local-ads.component.html',
  styleUrls: ['./local-ads.component.scss']
})
export class LocalAdsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
